module.exports = __webpack_public_path__ + "media/images/version_merge/why_user-7e39f3f4c91fa6934ce25b3eadc8d76b.svg";